<template>
  <div class="schedule container">
    <indexTitle english_title="Schedule" chinese_title="年度全台檔期"></indexTitle>
    <div class="row">
      <div class="schedule_item row col-lg-6 col-12" v-for="(exhi, index) in exhibit_data2.slice(from, to)"
        :key="exhi.id" itemscope itemtype="http://schema.org/ExhibitionEvent">
        <div class="col-lg-4 col-4" style="padding:0;">
          <div class="schedule_image_box"><a :href="'https://' + exhi.exhibit_domain.domain" target="_blank"><img
                :src="exhi.image2_url" :alt="exhi.short" itemprop="image" /></a></div>
        </div>
        <div class="schedule_info col-lg-8 col-8">
          <h3><a :href="'https://' + exhi.exhibit_domain.domain" target="_blank" v-html="exhi.short" itemprop="name"></a>
          </h3> <!--schedule_extro.slice(from,to)[index]-->
          <p><i class="fa fa-calendar"></i><span v-html="' ' + exhi.start_date + '~' + exhi.end_date.slice(5, 10)"
              itemprop="startDate"></span></p>
          <p itemprop="location"><i class="fa fa-map-marker" style="width: 14.86px;text-align:center;"></i>
            {{ exhi.address.name }}</p>
          <p><a itemprop="url" :href="'https://' + exhi.exhibit_domain.domain" target="_blank">前往官網 ⇀</a></p>
        </div>
      </div>
    </div>
    <moreButton button_text="更多展覽" button_href="schedule"></moreButton>
  </div>
</template>

<script>
import IndexTitle from '@/components/index/IndexTitle'
import MoreButton from '@/components/index/MoreButton'

export default {
  name: 'schedule',
  props: ['exhibit_data2'],
  data() {
    return {
      schedule: [

      ],
      schedule_extro: [],
      from: 0,
      to: 8
    }
  },
  computed: {
  },
  components: {
    'indexTitle': IndexTitle,
    'moreButton': MoreButton
  },
  mounted() {
  }
}
</script>

<style lang="sass">
$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

.schedule 
  /* margin-left: 10px */
  a 
    color: #00a0e9
    text-decoration: none
    font-weight: bold
  .schedule_item 
    padding-bottom: 30px
    padding-left: 0
    padding-right: 0
    margin: 0 auto
    &:nth-child(odd) 
      border-right: 1px solid #00a0e9
    .schedule_image_box
      width: 80%
      margin: auto
      img 
        display: block
        width: 100%
        max-width: 100%
        margin: auto
        box-shadow: 0 0 10px #cfcfcf
    .schedule_info 
      padding: 0
      h3 
        margin: 0
        width: 85%
        font-size: 17px
        height: 40px
      p 
        font-size: 15px
        // margin: 0
        &:nth-child(2) 
          margin-top: 10px
        &:nth-child(3) 
          margin-top: 5px
        &:nth-child(4) 
          // margin-top: 10px
  @include pc-width
    .schedule_item 
      &:nth-child(odd) 
        border-right: 0
      .schedule_info
        h3 
          width: 95%
  @include mobile-width 
    .schedule_item 
      .schedule_info
        h3 
          font-size: 15px
        p 
          font-size: 13px

.schedule
  .title_border 
    display: none

</style>
